import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillAmountStyled } from './TrlPillAmount.styles';

export const TrlPillAmount = () => {
  return (
    <TrlPillAmountStyled label={<FormattedMessage id="TRLT_UI-AMOUNT" />} />
  );
};
